import { call, put, takeEvery } from 'redux-saga/effects';

// Group Redux States
import {
  GET_WARDS,
  GET_CONSTITUENCIES,
  GET_COUNTIES,
  GET_REGIONS,
} from './actionTypes';
import {
  getCountiesSuccess,
  getCountiesFail,
  getRegionsSuccess,
  getRegionsFail,
  getSubCountiesSuccess,
  getSubCountiesFail,
  getWardsSuccess,
  getWardsFail,
} from './actions';
// toast
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  getCounties,
  getRegions,
  getSubCounties,
  getWards,
} from 'helpers/location_helper';

function* fetchRegions({ payload }) {
  try {
    const { addresses, ids, filter } = payload;
    const response = yield call(getRegions);
    if (filter) {
      let d = response?.filter((s) =>
        addresses?.map((r) => r?.regionId)?.includes(s.id),
      );
      yield put(getRegionsSuccess(d));
      return;
    }
    yield put(getRegionsSuccess(response));
  } catch (error) {
    console.log('Error fetching regions:', error);
    yield put(getRegionsFail(error));
  }
}

function* fetchCounties({ payload }) {
  try {
    const { addresses, ids, filter } = payload;
    const response = yield call(getCounties, ids);
    if (filter) {
      let d = response?.filter((s) =>
        addresses?.map((r) => r?.countyId)?.includes(s.id),
      );
      yield put(getCountiesSuccess(d));
      return;
    }
    yield put(getCountiesSuccess(response));
  } catch (error) {
    yield put(getCountiesFail(error));
  }
}

function* fetchSubCounties({ payload }) {
  try {
    const { addresses, ids, filter } = payload;
    const response = yield call(getSubCounties, ids);
    if (filter) {
      let d = response?.filter((s) =>
        addresses?.map((r) => r?.constituencyId)?.includes(s.id),
      );
      yield put(getSubCountiesSuccess(d));
      return;
    }
    yield put(getSubCountiesSuccess(response));
  } catch (error) {
    yield put(getSubCountiesFail(error));
  }
}

function* fetchWards({ payload }) {
  const { addresses, ids, filter } = payload;
  try {
    const response = yield call(getWards, ids);
    if (filter) {
      let d = response?.filter((s) =>
        addresses?.map((r) => r?.wardId)?.includes(s.id),
      );
      yield put(getWardsSuccess(d));
      return;
    }
    yield put(getWardsSuccess(response));
  } catch (error) {
    yield put(getWardsFail(error));
  }
}

function* locationSaga() {
  yield takeEvery(GET_WARDS, fetchWards);
  yield takeEvery(GET_CONSTITUENCIES, fetchSubCounties);
  yield takeEvery(GET_COUNTIES, fetchCounties);
  yield takeEvery(GET_REGIONS, fetchRegions);
}

export default locationSaga;
